// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__prIqS","option":"styles_option__2fN_g","active":"styles_active__3zUCK"};